import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-marker",
  "use": "spr-marker-usage",
  "viewBox": "0 0 48 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 60\" id=\"spr-marker\"><defs><path id=\"spr-marker_a\" d=\"M736 264c-13.26 0-24 10.99-24 24.54 0 13.76 11.67 22.84 24 35.46 12.33-12.62 24-21.7 24-35.46 0-13.55-10.75-24.54-24-24.54\" /></defs><use fill=\"currentColor\" xlink:href=\"#spr-marker_a\" transform=\"translate(-712 -264)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/marker.svg
// module id = 271
// module chunks = 0